import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Tween, Easing } from '@tweenjs/tween.js';
import CardSystem, { getCardHandler } from '../../Card/CardSystem';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import Armature from '../../../Prototype/Armature';
import Renderable from '../../../Component/Renderable';
import { AwaitIterators, PlayAnimation } from '../AnimationHelper';
import { DragonbonesDefault } from './DragonbonesDefault';
import SpriteComponent from '../../../Component/Render/Sprite';
import TransformComponent from '../../../Component/Transform';
import { UIEvent } from 'System/UI/BaseUISystem';

interface ICardRockMetaData {
    system: CardSystem;
    targetCards: BaseCard[];
}

export class CardRock extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: ICardRockMetaData
    ): IterableIterator<number> {
        meta.system.scene.emit(UIEvent.DISABLE_INTERACTIVITY);
        
        const animsToPlay = [];

        const sortedCards = [...meta.targetCards].sort((a, b) => {
            const aYPos = a.getComponent(TransformComponent).position.y;
            const bYPos = b.getComponent(TransformComponent).position.y;
            return bYPos - aYPos;
        });
        sortedCards.forEach(card => {
            meta.system.animator.addChild(card);
        });
        for (let card of meta.targetCards) {
            const pickaxeArmature = GameObject.Instantiate(Armature, {
                name: 'pickaxeArmature',
                dragonbonesName: 'pickaxe03_pickaxe',
                armatureName: 'card_pickaxe_axe',
                alpha: 0,
                playOnStart: false,
            });
            card.addChild(pickaxeArmature);

            card
                .getChildByName(BaseCard.CARD_FRONT_NAME)
                .getComponent(SpriteComponent).visible = false;

            const cardArmature = card.getChildByName('cardArmature');
            cardArmature.getComponent(Renderable).alpha = 1;

            animsToPlay.push(
                PlayAnimation(
                    new DragonbonesDefault(cardArmature, {
                        animationName: 'destroy',
                        playTimes: 1,
                    })
                )
            );

            animsToPlay.push(
                PlayAnimation(
                    new DragonbonesDefault(pickaxeArmature, {
                        playTimes: 1,
                    })
                )
            );
            animsToPlay.push(
                this.startTween(
                    this.getAlphaTween(
                        pickaxeArmature.getComponent(Renderable),
                        1,
                        300
                    )
                )
            );
        }

        yield* AwaitIterators(animsToPlay);
        meta.targetCards.forEach((card) => card.getComponent(Renderable).visible = false);
        meta.system?.scene?.emit(UIEvent.RESTORE_INTERACTIVITY);
    }

    private getAlphaTween(
        renderable: Renderable,
        alpha: number,
        duration: number = 250,
        easing: (k: number) => number = Easing.Exponential.InOut
    ): Tween {
        return this.getTween(renderable)
            .to({ alpha }, duration)
            .easing(easing);
    }
}
